import { useMutation } from '@tanstack/react-query';

/**
 * A mutation for copying to the clipboard
 * @returns 
 */
export function useCopyToClipboardMutation() {
  return useMutation({
    mutationFn: async (content: string) => {
      return navigator.clipboard.writeText(content);
    }
  });
}
